import { subscriptions_preferences_form } from './forms/subscriptions_preferences_form';
import { data_hub } from './forms/data_hub';
import { data_hub_form } from './forms/data_hub_forms';
import { get_boolean_query_param } from './helpers/index';
import './forms/data_hub_html_element';

window.subscriptions_preferences_form = subscriptions_preferences_form;
window.data_hub = data_hub;
window.data_hub_form = data_hub_form;
window.get_boolean_query_param = get_boolean_query_param;